import {
  Home,
  About,
  Careers,
  Insight,
  Insights,
  Join,
  HomeV2,
  HowItWorks,
} from './pages'
import { Navigation, Footer } from './components'

import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import '../sass/styles.scss'
import * as Sentry from '@sentry/browser'
import Hotjar from '@hotjar/browser'

const ENV_HOSTNAMES = {
  'with.co': 'production',
  'withcodev.wpengine.com': 'staging',
}

if (
  process.env.NODE_ENV === 'production' &&
  ENV_HOSTNAMES[document.location.host]
) {
  Sentry.init({
    dsn: 'https://285075e52425419a9e4857c43a512420@o1153557.ingest.sentry.io/6242694',
    environment: ENV_HOSTNAMES[document.location.host],
  })
}

const HOTJAR_SITE_IDS = {
  'with.co': 3515495,
  'withcodev.wpengine.com': 3515494,
}
const hotjarSiteId = HOTJAR_SITE_IDS[document.location.host]
const hotjarVersion = 6

Hotjar.init(hotjarSiteId, hotjarVersion)

const params = new URLSearchParams(window.location.search)
const utmCampaign = params.get('utm_campaign')
if (utmCampaign) {
  document.cookie = `utm_campaign=${utmCampaign}`
}

class Site {
  constructor() {
    document.querySelector('.navigation') && new Navigation()
    document.querySelector('.footer__emailCta') && new Footer()
    document.querySelector('.homev2') && new HomeV2()
    new Home()
    new About()
    new Careers()
    new Insights()
    new Insight()
    new HowItWorks()

    new Join({
      isProduction: ENV_HOSTNAMES[document.location.host] === 'production',
    })

    if (this.isTouchEnabled()) {
      document.body.classList.add('touch')
    } else {
      document.body.classList.add('no-touch')
    }

    if (this.getMobileOS() === 'iOS') {
      document.body.classList.add('iOS')
    }
  }

  isTouchEnabled() {
    return (
      'ontouchstart' in window ||
      navigator.maxTouchPoints > 0 ||
      navigator.msMaxTouchPoints > 0
    )
  }

  getMobileOS() {
    const ua = navigator.userAgent
    if (/android/i.test(ua)) {
      return 'Android'
    } else if (
      /iPad|iPhone|iPod/.test(ua) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
    ) {
      return 'iOS'
    }
    return 'Other'
  }
}

new Site()
